// extracted by mini-css-extract-plugin
module.exports = {"title":"Burn_title__2Vk2z","text":"Burn_text__1VT7L","info":"Burn_info__3G5cO","input":"Burn_input__NZr1s","btns":"Burn_btns__3zbvH","button":"Burn_button__gXr0G"};